





































import { Vue, Component, Prop, Ref, Watch, Emit } from 'vue-property-decorator'

@Component
export default class WildRiftDraftOption extends Vue {
  @Prop({ type: String, default: null })
  id!: string

  @Prop({ type: String, default: null })
  icon!: string

  @Prop({ type: String })
  displayName!: string

  @Prop({ type: String, default: 'draft-option' })
  name!: string

  @Prop({ type: Boolean, default: true })
  selectable!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: Boolean, default: false })
  waiting!: boolean

  @Prop({ type: Boolean, default: false })
  picking!: boolean

  @Prop({ type: String, default: '' })
  value!: string

  @Ref('radioButton')
  radioButton!: HTMLInputElement

  @Watch('value')
  onValueChanged(newVal: string) {
    if (!this.radioButton) return
    this.radioButton.checked = newVal === this.id
  }

  @Emit('input')
  onRadioButtonChanged() {
    return this.id
  }

  onRadioButtonChangedDelayed() {
    setTimeout(this.onRadioButtonChanged, 100)
  }

  mounted() {
    this.onValueChanged(this.value)
  }
}
